import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { ILatestNews, ITag } from '@core/interfaces/ilatest-news';

@Injectable({
  providedIn: 'root',
})
export class LatestNewsService {
  constructor(private data: DataService) { }

  getAll(): Observable<ILatestNews[]> {
    return this.data.get('latest-news');
  }

  getLatestNewsById(id: number): Observable<ILatestNews[]> {
    return this.data.get(`latest-news/${id}`);
  }

  saveLatestNews(news: FormData, message?: string) {
    return this.data.post('latest-news', news, message);
  }

  updateLatestNews(news: ILatestNews[], message?: string) {
    return this.data.put('latest-news', news, message);
  }

  deleteLatestNews(id: number, message?: string) {
    return this.data.delete(`latest-news/${id}`, message);
  }

  getTags(): Observable<ITag[]> {
    return this.data.get('latest-news/all-tags');
  }
}
